<div *ngIf="groupMembers">
  <p-pickList
    #pickListSelector
    [responsive]="true"
    [source]="nonGroupMembers"
    [trackBy]="trackByFunction"
    [target]="groupMembers"
    [sourceHeader]="groupConfig?.holderHeader"
    [targetHeader]="groupConfig?.memberHeader"
    (onMoveToTarget)="addMembers($event.items)"
    (onMoveToSource)="removeMembers($event.items)"
    (onMoveAllToTarget)="addMembers($event.items)"
    (onMoveAllToSource)="removeMembers($event.items)"
    [showSourceControls]="false"
    [showTargetControls]="groupConfig?.isOrderable"
    [targetStyle]="{ height: '250px' }"
    [sourceStyle]="{ height: '250px' }"
    filterBy="name"
    [dragdrop]="true"
    (onTargetReorder)="groupConfig?.isOrderable ? reorderMembers() : ''"
  >
    <ng-template let-item pTemplate="item">
      <div class="inline">{{ getRepr(item) }}</div>
    </ng-template>
  </p-pickList>
</div>
